import { forwardRef, type HTMLAttributes } from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/shared/utils/style.util";

const cardVariants = cva(
  [
    "bg-atelier-surface-raised",
    "rounded-atelier-lg",
    "transition-colors duration-[120ms] ease-out",
  ].join(" "),
  {
    variants: {
      variant: {
        bordered: "border border-atelier-border",
        elevated: "shadow-atelier-md",
        plain: "",
      },
      padding: {
        none: "",
        sm: "p-3",
        md: "p-4",
        lg: "p-6",
      },
      interactive: {
        true: "cursor-pointer hover:bg-atelier-surface-muted atelier-focus-ring",
        false: "",
      },
    },
    defaultVariants: {
      variant: "bordered",
      padding: "md",
      interactive: false,
    },
  },
);

type CardVariantsProps = VariantProps<typeof cardVariants>;

type CardProps = HTMLAttributes<HTMLDivElement> & CardVariantsProps;

const Card = forwardRef<HTMLDivElement, CardProps>(
  ({
    variant, padding, interactive, className, ...props
  }, ref) => (
    <div
      ref={ref}
      className={cn(
        cardVariants({ variant, padding, interactive }),
        className,
      )}
      {...props}
    />
  ),
);

Card.displayName = "Atelier.Card";

export { Card, cardVariants };
export type { CardProps, CardVariantsProps };
